export function shuffle(array: any[]): any[] {
    const a = array.slice();
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

export function intVal(thing: any, defaultVal: number = 0): number {
    const value = parseInt(thing, 10);
    return isNaN(value) ? defaultVal : value;
}

export function arrayRandom(array: any[]): any {
    return array[Math.floor(Math.random()*array.length)];
}


// WEBPACK FOOTER //
// ./src/utils.ts